<template>
	<div>
		<h1>Signatures</h1>
		<a class="btn btn-primary" href="#/backoffice/signatures/add">Add signature</a>
		<div class="table-responsive">
			<table class="table table-bordered table-hover">
				<thead>
				<tr>
					<th>sig_token</th>
					<th>organization</th>
					<th>total usage</th>
					<th>actions</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="rec in signaturesList">
					<th>{{rec._id}}</th>
					<th>{{rec.organization}}</th>
					<th><span v-if="rec.statistics && rec.statistics.files_singed">{{rec.statistics.files_singed.total}}</span></th>
					<th>
						<a :href="'#/backoffice/signatures/statistics/'+rec._id">Stats</a>
						<button class="btn btn-link" v-on:click="onDelete(rec)">Delete</button>
					</th>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import ApiService from "../../../libs/ApiService";

	export default {
		name: "Signatures",
		data() {
			return {
				signaturesList: []
			}
		},
		methods: {
			async onDelete(sign) {
				let answer = confirm("Are you sure?\nthis will disconnect any user using this signature");
				if (answer) {
					await ApiService.delete('/private/signatures/' + sign._id);
					this.loadSignatures();

				}
			},
			loadSignatures() {
				let $scope = this;
				ApiService.get('/private/signatures').then(function (res) {
					$scope.signaturesList = res.data;
				});
			}
		},
		mounted() {
			this.loadSignatures();
		}
	}
</script>

<style scoped>

</style>